import { Menu, MenuItem, Divider, IconButton, LinearProgress, Button, Box } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { useState } from "react";
import { disconnect, setActiveDialog } from "store/app";
import { Menu as MenuIcon } from "mdi-material-ui";
import { DialogType } from "store/app/types";
import { Link } from "react-router-dom";

const UserMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { user, isLoading } = useAppSelector((state) => state.app);
  const dispatch = useAppDispatch();
  const handleLogout = () => {
    dispatch(disconnect());
  };
  return (
    <>
      {
        isLoading ? <Box sx={{ width: '30px' }}><LinearProgress color="primary"/></Box> : (
          <>
            {
              user ? (
                <IconButton onClick={(e) => setAnchorEl(e.currentTarget as any)} color="primary">
                  <MenuIcon />
                </IconButton>
              ) : (
                <>
                  <Button
                    size="small"
                    color="secondary"
                    className="me-1"
                    onClick={() => dispatch( setActiveDialog(DialogType.Login) )}
                  >
                    Login
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    onClick={() => dispatch( setActiveDialog(DialogType.Signup) )}
                  >
                    Signup
                  </Button>
                </>
              )
            }
          </>
        )
      }
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          component={Link}
          to="/dashboard/purchases"
          onClick={() => setAnchorEl(null)}
        >
          My Purchases
        </MenuItem>
        <MenuItem
          component={Link}
          to="/dashboard/security"
          onClick={() => setAnchorEl(null)}
        >
          Security
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
            handleLogout();
            setAnchorEl(null);
          }}
        >
          Logout
        </MenuItem>
      </Menu>

    </>
  );
};
export default UserMenu;
